module.exports = "/_next/static/images/nhlIcon@3x-da1045b364b86c2a94165d47aaee4544.png";